import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconStoreRepair from '@/icons/StoreRepair.svg';

import { useFilters } from '../FiltersState';

export const FiltersArticleWorkshop = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    articleWorkshopSelections: { articleWorkshopSelections, setArticleWorkshopSelections },
  } = useFilters();

  const selectedCount = articleWorkshopSelections.length;

  return (
    <DesktopEntityFilter
      selectedEntities={articleWorkshopSelections}
      setSelectedEntities={setArticleWorkshopSelections}
      traits={['workshop']}
      tag={tag}
      label={t({
        id: 'settings.organization.entities.agreements.filters.article_workshop.label',
        message: 'Article workshop',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.entities.agreements.filters.article_workshop.search',
        message: 'Search workshops',
      })}
      icon={<IconStoreRepair />}
      tagSelectedCountLabel={i18n._({
        id: 'settings.organization.entities.agreements.filters.article_workshop.multiple',
        message: '{selectedCount} workshops',
        values: { selectedCount },
      })}
    />
  );
};
